(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('FaqService', FaqService)

    /** @ngInject */
    function FaqService(HttpService) {
        const FaqService = {
            getCategories: getCategories,
            getAllByParameters: getAllByParameters,
            getById: getById
        }

        return FaqService;

        function getCategories() {
            return HttpService.get('/faqs/categories');
        }

        function getAllByParameters(params) {
            return HttpService.get('/faqs', {
                params
            });
        }

        function getById(faqId) {
            return HttpService.get(`/faqs/${faqId}`);
        }
    }
}());